<template>
  <transition name="fade">
        <div class="spinner"><a-spin> <a-icon slot="indicator" type="loading" style="font-size: 24px" spin /> </a-spin></div>
  </transition>
</template>

<script>
export default {
  name: 'Loading',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.spinner {
  position: absolute !important;
  top:0;
  left:0;
  right:0;
  bottom:0;
  pointer-events: none;
  .ant-spin {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .anticon-spin {
      animation-duration: .5s;
    }
  }
}
</style>
